export const API_BASE_URL_AWS = 'http://54.210.109.209:5000'
export const API_BASE_URL_LOCAL = 'https://localhost:7277'
export const API_BASE_URL_SAUCY = 'https://api.saucy.com.pk'
export const API_BASE_URL_AZURE = 'https://healthyhomes.azurewebsites.net'
export const API_BASE_URL_REALIABLE = 'https://api.reliablehomecare.co.nz'


